/* person-card-header.tsx generated by @compiled/babel-plugin v0.38.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./person-card-header.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl-next';
import { IconButton } from '@atlaskit/button/new';
import DepartmentIcon from '@atlaskit/icon/core/department';
import LocationIcon from '@atlaskit/icon/core/location';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Inline, Text } from '@atlaskit/primitives/compiled';
import ReportingLines from '@atlassian/reporting-lines';
import { useAIAnswerContext } from '../../ai-answer-dialog/ai-answer-context';
import { useAnalytics } from '../../common/controller/analytics';
import { messages } from '../../messages';
import { isHello } from '../../utils';
import { onPersonCardOrgChartCardClicked, onPersonCardOrgChartDwelled, onPersonCardOrgChartShown } from '../analytics';
import { KnowledgeCardHeader } from '../common/knowledge-card-header';
import { KnowledgeCardsTopics } from '../knowledge-cards-topics';
import { KnowledgeCardsPicture } from '../styled';
import { KnowledgeCardsIntentType } from '../types';
import { useTeamsAppLinks } from '../use-teams-app-links';
var ORG_CHART_DWELL_THRESHOLD = 3000;
var IconPaddingStyles = {
  default: "_u5f31b66 _19bv1b66"
};
export var PersonCardHeader = function PersonCardHeader(_ref) {
  var name = _ref.name,
    accountId = _ref.accountId,
    email = _ref.email,
    avatarUrl = _ref.avatarUrl,
    profileUrl = _ref.profileUrl,
    jobTitle = _ref.jobTitle,
    department = _ref.department,
    location = _ref.location,
    time = _ref.time;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];
  var cloudId = commonAttributes.cloudId,
    sessionId = commonAttributes.sessionId;
  var showAITopics = fg('kd_topics_in_person_card');
  var _useTeamsAppLinks = useTeamsAppLinks({
      type: KnowledgeCardsIntentType.PERSON,
      currentUserId: accountId !== null && accountId !== void 0 ? accountId : '',
      cloudId: cloudId
    }),
    profileHref = _useTeamsAppLinks.profileHref,
    profileOnNavigate = _useTeamsAppLinks.profileOnNavigate;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOrgChartModalOpen = _useState2[0],
    setIsOrgChartModalOpen = _useState2[1];
  useEffect(function () {
    var dwellTimeout;
    if (isOrgChartModalOpen) {
      dwellTimeout = setTimeout(function () {
        fireAnalyticsEvent(onPersonCardOrgChartDwelled(commonAttributes));
      }, ORG_CHART_DWELL_THRESHOLD);
    }
    return function () {
      clearTimeout(dwellTimeout);
    };
  }, [isOrgChartModalOpen, fireAnalyticsEvent, commonAttributes]);
  var subText = [jobTitle, department].filter(function (text) {
    return !!text;
  }).join(', ');
  var trimmedSubText = subText.length > 250 ? "".concat(subText.slice(0, 250), "...") : subText;
  var orgText = /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtlest"
  }, trimmedSubText);
  var timeAndLocationComponent = (location || time) && /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: IconPaddingStyles.default
  }, /*#__PURE__*/React.createElement(LocationIcon, {
    label: ""
  })), /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    color: "color.text.subtlest"
  }, /*#__PURE__*/React.createElement(Inline, {
    space: "space.050"
  }, location && /*#__PURE__*/React.createElement(Text, null, location), time && location && /*#__PURE__*/React.createElement(Text, null, "\u2022"), time && /*#__PURE__*/React.createElement(Text, null, time))));
  var additionalInfo = /*#__PURE__*/React.createElement(React.Fragment, null, timeAndLocationComponent, showAITopics && /*#__PURE__*/React.createElement(KnowledgeCardsTopics, {
    cloudId: cloudId,
    userId: accountId !== null && accountId !== void 0 ? accountId : '',
    userName: name,
    sessionId: sessionId,
    v2styles: true
  }));
  var media = /*#__PURE__*/React.createElement(KnowledgeCardsPicture, {
    src: avatarUrl || '',
    alt: name
  });
  var handleLinkClick = function handleLinkClick(e) {
    if (fg('platform-adopt-teams-nav-config')) {
      profileOnNavigate(e);
    }
  };
  var openOrgChartModal = function openOrgChartModal() {
    setIsOrgChartModalOpen(true);
    fireAnalyticsEvent(onPersonCardOrgChartShown(commonAttributes));
  };
  var closeOrgChartModal = function closeOrgChartModal() {
    return setIsOrgChartModalOpen(false);
  };
  var orgChartButton = (isHello(cloudId) || fg('kd_person_card_org_chart_button')) && accountId ? /*#__PURE__*/React.createElement(IconButton, {
    icon: DepartmentIcon,
    label: formatMessage(messages.knowledge_cards_person_org_chart_label),
    isTooltipDisabled: false,
    onClick: openOrgChartModal,
    testId: "person-card-org-chart-button"
  }) : null;
  var ClickWrapper = function ClickWrapper(_ref2) {
    var children = _ref2.children,
      userId = _ref2.userId;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
      React.createElement("div", {
        key: "".concat(userId, "-org-chart-card"),
        onClick: function onClick() {
          fireAnalyticsEvent(onPersonCardOrgChartCardClicked(commonAttributes));
        }
      }, children)
    );
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(KnowledgeCardHeader, {
    name: name,
    email: email,
    profileUrl: fg('platform-adopt-teams-nav-config') ? profileHref : profileUrl || '',
    profileLinkText: formatMessage(messages.ai_answer_who_questions_view_profile),
    media: media,
    orgText: orgText,
    additionalInfo: additionalInfo,
    onLinkClick: handleLinkClick,
    headerActions: orgChartButton
  }), /*#__PURE__*/React.createElement(ModalTransition, null, accountId && isOrgChartModalOpen && /*#__PURE__*/React.createElement(Modal, {
    onClose: closeOrgChartModal,
    testId: "person-card-org-chart-modal"
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    hasCloseButton: true
  }, /*#__PURE__*/React.createElement(ModalTitle, null, formatMessage(messages.knowledge_cards_person_org_chart_modal_header))), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(ReportingLines, {
    userId: accountId,
    product: "personKnowledgeCardOrgChart",
    WrappedWithProfilecard: ClickWrapper
  })), /*#__PURE__*/React.createElement(ModalFooter, null))));
};